// Malaysian IC numbers read as 010203-04-0506 rather than one run of digits.
// Anything else - a passport, an older format, a company number - is left
// exactly as it came in.
export default function formatIcNo(value) {
  const digits = String(value ?? "").trim();

  if (!/^\d{12}$/.test(digits)) return value;

  return `${digits.slice(0, 6)}-${digits.slice(6, 8)}-${digits.slice(8)}`;
}
